/**
 * @author Mevan Nirosh
 * @version 0.1
 * @since 4/27/2023
 */
import React, { useState } from "react";
import labelsEN from "../../../locales/en/translation.json";
import CreateNewRoleModal from "./components/CreateNewRoleModal";
import { Fab } from "@mui/material";
import { Tabs, Tab, Badge } from "react-bootstrap";
import AddIcon from "@mui/icons-material/Add";
import ApprovedRoles from "./components/ApprovedRoles";
import PendingRoles from "./components/PendingRoles";

const UserPermissions = () => {
  const AUTO_APPROVE = localStorage.getItem("SET_AUTO_APPROVE")

  const [pendingCount, setPendingCount] = useState(0);
  const [isChange, setIsChange] = useState(false);
  const [isPendingChange, setIsPendingChange] = useState(false);

  //modals state
  const [createModalOpen, setCreateModalOpen] = useState(false);

  return (
    <div>
      <div style={{ display: "flex", position: "relative" }}>
        <h1>{labelsEN.app_userpermissions_page_title}</h1>
        <Fab
          onClick={() => setCreateModalOpen(true)}
          color="success"
          variant="extended"
          sx={{ position: "absolute", right: 0 }}
        >
          <AddIcon sx={{ mr: 1 }} />
          Create new
        </Fab>
      </div>
      <br />
      <br />
      <div>
        <Tabs
          defaultActiveKey="Approved"
          id="uncontrolled-tab-example"
          className="mb-3"
        >
          <Tab eventKey="Approved" title={"Approved"}>
            <ApprovedRoles
              setIsPendingChange={setIsPendingChange}
              isPendingChange={isPendingChange}
            />
          </Tab>
          {AUTO_APPROVE === "false" && (
            <Tab
              eventKey="Pending"
              title={
                <div>
                  Pending Approval{" "}
                  {pendingCount !== 0 && (
                    <Badge bg="danger">{pendingCount}</Badge>
                  )}
                </div>
              }
            >
              <PendingRoles
                setIsPendingChange={setIsPendingChange}
                isPendingChange={isPendingChange}
                isChange={isChange}
                setIsChange={setIsChange}
                setPendingCount={setPendingCount}
              />
            </Tab>
          )}
        </Tabs>
      </div>

      <CreateNewRoleModal
        open={createModalOpen}
        onClose={() => setCreateModalOpen(false)}
        setIsChange={setIsChange}
        setIsPendingChange={setIsPendingChange}
      />
    </div>
  )
};
export default UserPermissions;
